module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/partner/partner.component.css
// module id = ./src/app/main-settings/partner/partner.component.css
// module chunks = main